import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#00f2ff",
    },
    secondary: {
      main: "#ff9d00",
    },
    background: {
      default: "#03080f",
      paper: "rgba(3, 8, 15, 0.8)",
    },
    text: {
      primary: "#e0faff",
      secondary: "rgba(224, 250, 255, 0.7)",
    },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    h1: {
      fontFamily: "'Syncopate', sans-serif",
      fontWeight: 700,
    },
    h2: {
      fontFamily: "'Syncopate', sans-serif",
      fontWeight: 700,
    },
    h3: {
      fontFamily: "'Syncopate', sans-serif",
      fontWeight: 700,
    },
    h4: {
      fontFamily: "'Syncopate', sans-serif",
      fontWeight: 700,
    },
    h5: {
      fontFamily: "'Orbitron', sans-serif",
      fontWeight: 600,
    },
    h6: {
      fontFamily: "'Orbitron', sans-serif",
      fontWeight: 600,
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: "2rem",
          paddingBottom: "2rem",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(0, 242, 255, 0.03)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(0, 242, 255, 0.15)",
          borderRadius: "4px",
          transition: "all 0.4s ease",
          "&:hover": {
            borderColor: "#00f2ff",
            boxShadow: "0 0 20px rgba(0, 242, 255, 0.15)",
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(0, 242, 255, 0.1)",
          "& .MuiTableCell-root": {
            color: "#00f2ff",
            fontFamily: "'Orbitron', sans-serif",
            textTransform: "uppercase",
            fontSize: "0.75rem",
            fontWeight: 700,
            letterSpacing: "1px",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid rgba(0, 242, 255, 0.05)",
        },
      },
    },
  },
});
